import React from 'react';

import { Container } from './styles';

const Forbidden: React.FC = () => {
  return (
    <Container>
      <h1>Acesso negado</h1>

      <p>Você não possui permissão para acessar essa página.</p>
    </Container>
  );
};

export default Forbidden;
